import { TabPanel } from '@headlessui/react';
import FormattedCurrency from '@otovo/shared/components/Currency/FormattedCurrency';
import m from '@otovo/shared/components/PurchaseModelComparison/messages';
import Button from '@otovo/shared/rainbow/Button/Button';
import { FormattedMessage as T } from 'react-intl';
import SellingPointsOwnership from './SellingPointsOwnership';

type Props = {
  startingPriceOwnership: number;
};

const Ownership = ({ startingPriceOwnership }: Props) => {
  return (
    <TabPanel className="grid grid-cols-1 gap-10 md:grid-cols-2">
      <SellingPointsOwnership />
      <div className="flex flex-col space-y-14 text-grey-90">
        <div className="w-full">
          <p className="mb-3 text-base text-grey-60">
            <T {...m.ownershipIntroduction} />
          </p>
        </div>
        <div className="w-full">
          <p className="mb-10 tracking-tight text-grey-60 sm:text-2xl">
            <T {...m.fromPrice} />{' '}
            <span className="text-[55px] font-semibold text-grey-90">
              <FormattedCurrency value={startingPriceOwnership} />
            </span>
          </p>
          <Button
            type="button"
            className="w-full text-lg"
            onClick={() => {
              window.scroll({
                top: 0,
                behavior: 'smooth',
              });
            }}
          >
            <T {...m.scrollToTopButton} />
          </Button>
        </div>
      </div>
    </TabPanel>
  );
};

export default Ownership;
